import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

export default function TelusLimitDetailFields({ reportLimitDetail, language, onChange }) {
    const [fromAddress, setFromAddress] = useState(reportLimitDetail.fromAddress);
    const [toAddress, setToAddress] = useState(reportLimitDetail.toAddress);
    const [serviceCount, setServiceCount] = useState(reportLimitDetail.serviceCount);

    useEffect(() => {
        setFromAddress(reportLimitDetail.fromAddress);
        setToAddress(reportLimitDetail.toAddress);
        setServiceCount(reportLimitDetail.serviceCount);
    }, [reportLimitDetail]);

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>{language === 'fr' ? 'De' : 'From Address'}</Form.Label>
                <Form.Control
                    size='sm'
                    type='text'
                    value={fromAddress}
                    onChange={e => {
                        setFromAddress(e.target.value);
                        onChange({ limitIndex: reportLimitDetail.limitIndex, fromAddress: e.target.value, toAddress, serviceCount });
                    }}
                    placeholder={language === 'fr' ? 'Adresse de départ' : 'Enter from address'}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>{language === 'fr' ? 'À' : 'To Address'}</Form.Label>
                <Form.Control
                    size='sm'
                    type='text'
                    value={toAddress}
                    onChange={e => {
                        setToAddress(e.target.value);
                        onChange({ limitIndex: reportLimitDetail.limitIndex, fromAddress, toAddress: e.target.value, serviceCount });
                    }}
                    placeholder={language === 'fr' ? 'Adresse de destination' : 'Enter to address'}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>{language === 'fr' ? 'Nombre de services marqués' : 'Number of Services marked'}</Form.Label>
                <Form.Control
                    size='sm'
                    type='number'
                    min='0'
                    value={serviceCount}
                    onChange={e => {
                        setServiceCount(e.target.value);
                        onChange({ limitIndex: reportLimitDetail.limitIndex, fromAddress, toAddress, serviceCount: e.target.value });
                    }}
                    placeholder={language === 'fr' ? 'Nombre de services marqués' : 'Number of Services marked'}
                />
            </Form.Group>
        </>
    );
}
